import {TranslatableResourceType} from 'types';

export const GROUPED_TRANSLATABLE_ROUTES = [
  {
    group: 'products',
    routes: [
      {
        resourceType: TranslatableResourceType.Product,
        title: 'products',
        url: '/product',
      },
      {
        resourceType: TranslatableResourceType.Collection,
        title: 'collections',
        url: '/collection',
      },
    ],
  },
  {
    group: 'onlineStore',
    routes: [
      {
        resourceType: TranslatableResourceType.OnlineStoreBlog,
        title: 'blogs',
        url: '/online_store_blog',
      },
      {
        resourceType: TranslatableResourceType.CookieBanner,
        title: 'cookieBanner',
        url: '/cookie_banner',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreArticle,
        title: 'blogPosts',
        url: '/online_store_article',
      },
      {
        resourceType: TranslatableResourceType.OnlineStorePage,
        title: 'pages',
        url: '/online_store_page',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreMenu,
        title: 'navigation',
        url: '/online_store_menu',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreFilterSetting,
        title: 'filterSettings',
        url: '/online_store_filter_setting',
      },
      {
        resourceType: TranslatableResourceType.Shop,
        title: 'store',
        url: '/shop',
      },
      {
        resourceType: TranslatableResourceType.ShopPolicy,
        title: 'policies',
        url: '/shop_policy',
      },
      {
        resourceType: TranslatableResourceType.Metaobject,
        title: 'metaobjects',
        url: '/metaobject',
      },
    ],
  },
  {
    group: 'theme',
    routes: [
      {
        resourceType: TranslatableResourceType.OnlineStoreThemeLocaleContent,
        title: 'defaultThemeContent',
        url: '/online_store_theme_locale_content',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreThemeSectionGroup,
        title: 'sectionGroups',
        url: '/online_store_theme_section_group',
      },
      {
        resourceType:
          TranslatableResourceType.OnlineStoreThemeSettingsDataSections,
        title: 'staticSections',
        url: '/online_store_theme_settings_data_sections',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreThemeJsonTemplate,
        title: 'templates',
        url: '/online_store_theme_json_template',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreThemeSettingsCategory,
        title: 'themeSettings',
        url: '/online_store_theme_settings_category',
      },
      {
        resourceType: TranslatableResourceType.OnlineStoreThemeAppEmbed,
        title: 'appEmbeds',
        url: '/online_store_theme_app_embed',
      },
    ],
  },
  {
    group: 'settings',
    routes: [
      {
        resourceType: TranslatableResourceType.EmailTemplate,
        title: 'notifications',
        url: '/email_template',
      },
      {
        resourceType: TranslatableResourceType.DeliveryProfile,
        title: 'shippingAndDelivery',
        url: '/delivery_profile',
        match: '/(packing_slip_template|delivery_profile)',
      },
    ],
  },
];
